import angular from 'angular'
import LocalizationStorage from '%app/js/common/services/localizationStorage';

let language = new LocalizationStorage().getLanguage();
if (language === 'en') {
    language = 'en-gb';
}
require('angular-i18n/angular-locale_' + language + '.js');
require('moment/locale/' + language + '.js');

const moment = require('moment-timezone');
const jQuery = require('jquery');

moment.locale(language);

global.moment = moment;
global.jQuery = jQuery;

require('bootstrap-daterangepicker/daterangepicker.js');
require('fork-angular-daterangepicker/js/angular-daterangepicker.js');

export default moment;
